import React from 'react';
import classNames from 'classnames';
import { AppI18n } from '../../../../../i18n';
import './index.scss';
import { ChosenCategory } from '../../utils/types';

export const Toggle = ({
  isLocation,
  setChosenCategory,
}: {
  isLocation: boolean;
  setChosenCategory: (category: ChosenCategory) => void;
}) => (
  <div className="flex toggle-container">
    <div
      onClick={() => setChosenCategory('location')}
      className={classNames('item flex flex-items-center', {
        active: isLocation,
      })}
    >
      <span className="text">
        <AppI18n k="sections.ideal_candidate.location_timezone.location.title" />
      </span>
    </div>
    <div
      onClick={() => setChosenCategory('timezone')}
      className={classNames('item flex flex-items-center', {
        active: !isLocation,
      })}
    >
      <span className="text">
        <AppI18n k="sections.ideal_candidate.location_timezone.timezone.title" />
      </span>
    </div>
    <div
      className={classNames('animation-bar', {
        active: isLocation,
        timezone: !isLocation,
      })}
    ></div>
  </div>
);
